import { fetchPost, getPhone } from ".";

export const validateUser = async (rawPhoneNumber, showError) => {
  let phoneNumber = await getPhone(rawPhoneNumber);
  const { body, error } = await fetchPost({
    data: { phoneNumber },
    url: "/api/phone-number",
    onError: console.error,
  });
  if (body) {
    window.localStorage.setItem("hub-userUuid", body.userUuid);
  }
  return { body, error };
};

export const deleteAllCookies = () => {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
};
